const flowStartedKey = 'minside.changeSigninEmail.started';

// B2C bruker denne koden når brukeren selv avbryter flyten. Da skal vi ikke vise feilmelding.
const userCancelledErrorCode = 'AADB2C90091';

// Parametrene B2C sender tilbake når user journeyen fullførte.
const tokenParameters = ['id_token', 'code', 'access_token'];

// Feilet flyten, sender vi brukeren til profilsiden med denne parameteren, slik at siden kan
// forklare hva som skjedde i en dialog brukeren selv lukker.
export const changeSigninEmailErrorParameter = 'error_description';
export const emailAlreadyInUseError = 'email.alreadyInUse';

export const markChangeSigninEmailStarted = () => sessionStorage.setItem(flowStartedKey, 'true');

export const consumeChangeSigninEmailStarted = (): boolean => {
  const started = sessionStorage.getItem(flowStartedKey) !== null;
  sessionStorage.removeItem(flowStartedKey);

  return started;
};

// Feiler REST-kallet i policyen (f.eks. fordi den nye e-posten allerede er i bruk), avbrytes
// user journeyen og B2C sender oss tilbake med error-parametre i query eller fragment.
export const hasChangeSigninEmailFailed = (search: string, hash: string): boolean => {
  const parsedQueryString = new URLSearchParams(search);
  // Fragmentet starter med #, som URLSearchParams ikke fjerner selv.
  const parsedHashString = new URLSearchParams(hash.replace(/^#/, ''));

  if (!parsedQueryString.get('error') && !parsedHashString.get('error')) return false;

  const errorDescription = `${parsedQueryString.get('error_description') ?? ''} ${parsedHashString.get('error_description') ?? ''}`;

  return errorDescription.indexOf(userCancelledErrorCode) === -1;
};

// Fullført flyt gir oss et token tilbake i query eller fragment. Det er ikke nok å se at flyten ble
// startet: gikk brukeren bare tilbake til Min Side uten å fullføre, ligger det ingen respons i
// url-en, og da skal sesjonen beholdes.
export const hasChangeSigninEmailSucceeded = (search: string, hash: string): boolean => {
  const parsedQueryString = new URLSearchParams(search);
  // Fragmentet starter med #, som URLSearchParams ikke fjerner selv.
  const parsedHashString = new URLSearchParams(hash.replace(/^#/, ''));

  if (parsedQueryString.get('error') || parsedHashString.get('error')) return false;

  return tokenParameters.some((parameter) => parsedQueryString.has(parameter) || parsedHashString.has(parameter));
};
